import React from 'react'
import './App.css'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import Navbar from './components/Navbar'
import Landing from './Landing'
import Fun from './Fun'
import Stox from './Stox'
import Thankyou from './Thankyou'
import Privacy from './components/Legal/Privacy'
import Terms from './components/Legal/Terms'
import Footer from './components/Footer'


function App() {
  
  return(
    <Router>
    <div className="App">
      {/* <Navbar/> */}
      <Switch>
        <Route path="/" exact component={Landing}/>
        <Route path="/privacy" component={Privacy}/>
        <Route path="/terms" component={Terms}/>
        <Route path="/stox" component={Stox}/>
        <Route path="/thankyou" component={Thankyou}/>
        <Route path="/fun" component={Fun}/>
      </Switch>
      <Footer/>
    </div>
    </Router>
  );
}

export default App;
